<template>
  <section class="contact-hero">
    <div class="hero-top">
      <div class="left-content">
        <div class="tag"><span class="pulse-dot"></span> SECURE CHANNEL - LISTENING NOW</div>
        <h1 class="main-title">
          Every Minute<br>
          Counts.<br>
          <span class="gradient-text">Talk to Us Now.</span>
        </h1>
        <p class="description">
          Stolen funds move fast — the sooner your case reaches an analyst, the more we can trace before the trail goes
          cold. Open a secure channel below and get a full case assessment within 24 hours.
        </p>

        <div class="hero-buttons">
          <button @click="navTo('/our-popular-services')" class="btn-primary">▣ OUR SERVICES</button>
          <button class="btn-secondary">📘 About Us</button>
        </div>

        <div class="quick-stats">
          <div class="q-stat">
            <div class="icon">🛡️</div>
            <div><strong>Encrypted Form</strong><br><span class="sub">RESPONSE &lt; 24H</span></div>
          </div>
          <div class="q-stat">
            <div class="icon">📞</div>
            <div><strong>Emergency Line</strong><br><span class="sub">LIVE 24/7</span></div>
          </div>
          <div class="q-stat">
            <div class="icon">💬</div>
            <div><strong>Analyst Chat</strong><br><span class="sub">AVG WAIT 3 MIN</span></div>
          </div>
        </div>
      </div>

      <div class="right-visual" ref="visualContainer">
        <div class="three-wrapper" ref="threeContainer"></div>


        <div class="status-card sc-1">
          <div class="sc-label">ANALYSTS ONLINE</div>
          <div class="sc-num">7</div>
          <div class="sc-status">READY TO RESPOND</div>
          <div class="bar"></div>
        </div>
        <div class="status-card sc-2">
          <div class="sc-label">AVG RESPONSE</div>
          <div class="sc-num">&lt;24H</div>
          <div class="sc-status">CASE ASSESSMENT</div>
          <div class="bar"></div>
        </div>
        <div class="status-card sc-3">
          <div class="sc-label">SIGNAL STATUS</div>
          <div class="sc-num">SECURE</div>
          <div class="sc-status">TLS 1.3 ENCRYPTED</div>
          <div class="bar"></div>
        </div>
        <div class="status-card sc-4">
          <div class="sc-label">QUEUE</div>
          <div class="sc-num">0</div>
          <div class="sc-status">WAITING NOW</div>
          <div class="bar"></div>
        </div>
        <div class="channel-badge"><span class="pulse-dot"></span> CHANNEL LIVE</div>
      </div>
    </div>

    <div class="hero-bottom">
      <div class="form-card">
        <h2 class="form-title">SEND US A MESSAGE</h2>
        <p class="form-desc">
          Report your scam case here. Our cryptocurrency recovery specialists will review your loss and help you reclaim
          your digital assets quickly and securely. Fill out the form below to get professional support from a trusted
          recovery expert.
        </p>

        <form @submit.prevent>
          <div class="form-grid">
            <div class="form-group"><label>NAME *</label><input type="text" placeholder="Name" v-model="form.name" />
            </div>
            <div class="form-group"><label>EMAIL *</label><input type="email" placeholder="Email"
                v-model="form.email" /></div>
            <div class="form-group"><label>PHONE NUMBER</label><input type="tel" placeholder="Phone Number"
                v-model="form.phone" /></div>
            <div class="form-group"><label>COUNTRY</label><input type="text" placeholder="Country"
                v-model="form.country" /></div>
          </div>

          <div class="form-group"><label>YOUR INQUIRY ABOUT</label><select v-model="form.inquiry">
              <option value="" disabled selected>Your inquiry about</option>
              <option value="scam">Scam</option>
              <option value="wallet">Wallet Access</option>
            </select></div>
          <div class="form-group"><label>MESSAGE</label><textarea placeholder="Message..."
              v-model="form.message"></textarea></div>

          <label class="terms"><input type="checkbox" v-model="form.terms" /> I accept the Terms & Conditions</label>
          <button @click="sendMessage" type="submit" class="send-btn">SEND MESSAGE ➤</button>
        </form>
      </div>

      <!-- <div class="info-panel">
        <div class="info-card color-1" @mousemove="handleTilt" @mouseleave="handleTiltLeave">
          <div class="icon-container">
            <div class="ring-anim"></div>
            <span class="ring-text">&lt;24H</span>
          </div>
          <div>
            <div class="ic-title">GUARANTEED RESPONSE TIME</div>
            <p>Every submission is reviewed by a real specialist — not a bot. Urgent cases can be prioritised and
              responded to within hours.</p>
          </div>
        </div>

        <div class="info-card color-2" @mousemove="handleTilt" @mouseleave="handleTiltLeave">
          <div class="info-icon">📞</div>
          <div><strong>HOTLINE</strong><br><span class="value">+1 (934) 201-3499</span></div>
        </div>

        <div class="info-card color-3" @mousemove="handleTilt" @mouseleave="handleTiltLeave">
          <div class="info-icon">✉</div>
          <div><strong>EMAIL ADDRESS</strong><br><span class="value">Admin@fraudcounsel.net</span></div>
        </div>

        <div class="info-card color-4" @mousemove="handleTilt" @mouseleave="handleTiltLeave">
          <div class="info-icon">💬</div>
          <div><strong>WHATSAPP</strong><br><span class="value">Available via WhatsApp Chat</span></div>
        </div>

        <div class="info-card color-5" @mousemove="handleTilt" @mouseleave="handleTiltLeave">
          <div class="info-icon">📍</div>
          <div><strong>HEADQUARTERS</strong><br><span class="value">250 International Pkwy, Lake Mary, FL 32746</span>
          </div>
        </div>

        <div class="info-card color-6" @mousemove="handleTilt" @mouseleave="handleTiltLeave">
          <div class="info-icon">🕒</div>
          <div>
            <strong>WORKING HOURS</strong>
            <div class="hours-grid">
              <span>MONDAY 24 HRS</span><span>TUESDAY 24 HRS</span>
              <span>WEDNESDAY 24 HRS</span><span>THURSDAY 24 HRS</span>
              <span>FRIDAY 24 HRS</span><span>SATURDAY 24 HRS</span>
              <span>SUNDAY 12AM-4PM</span>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </section>
</template>

<script>
import * as THREE from 'three';

export default {
  name: 'ContactHero',
  data() {
    return {
      form: { name: '', email: '', phone: '', country: '', inquiry: '', message: '', terms: false },
      scene: null, camera: null, renderer: null, group: null,
      animationId: null, targetRotX: 0, targetRotY: 0,
      resizeHandler: null
    };
  },
  mounted() {
    this.initThree();
    this.animate();

    this.resizeHandler = () => this.onResize();
    window.addEventListener('resize', this.resizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.handleGlobalMouseMove);
    window.removeEventListener('resize', this.resizeHandler);
    cancelAnimationFrame(this.animationId);
    if (this.renderer) {
      this.renderer.dispose();
      if (this.renderer.domElement && this.renderer.domElement.parentNode) {
        this.renderer.domElement.parentNode.removeChild(this.renderer.domElement);
      }
    }
  },
  methods: {
    handleTilt(e) {
      const card = e.currentTarget;
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const cx = rect.width / 2;
      const dx = (x - cx) / cx;
      card.style.transform = `perspective(800px) rotateY(${dx * 12}deg)`;
    },
    handleTiltLeave(e) {
      e.currentTarget.style.transform = 'perspective(800px) rotateY(0deg)';
    },
    onResize() {
      const container = this.$refs.threeContainer;
      if (!container || !this.renderer) return;
      this.camera.aspect = container.clientWidth / container.clientHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(container.clientWidth, container.clientHeight);
    },
    initThree() {
      const container = this.$refs.threeContainer;
      if (!container) return;

      this.scene = new THREE.Scene();
      this.camera = new THREE.PerspectiveCamera(60, container.clientWidth / container.clientHeight, 0.1, 1000);
      this.camera.position.z = 6;

      this.renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true });
      this.renderer.setSize(container.clientWidth, container.clientHeight);
      container.appendChild(this.renderer.domElement);

      this.scene.add(new THREE.AmbientLight(0xffffff, 0.6));
      const dirLight = new THREE.DirectionalLight(0xffffff, 0.8);
      dirLight.position.set(5, 10, 7);
      this.scene.add(dirLight);

      this.group = new THREE.Group();

      const centerGeo = new THREE.IcosahedronGeometry(1.2, 0);
      const centerMat = new THREE.MeshPhongMaterial({
        color: 0x4fd1c5, transparent: true, opacity: 0.8, flatShading: true
      });
      const centerMesh = new THREE.Mesh(centerGeo, centerMat);
      this.group.add(centerMesh);

      const outerGeo = new THREE.IcosahedronGeometry(2.2, 0);
      const outerMat = new THREE.MeshBasicMaterial({
        color: 0x4fd1c5, wireframe: true, transparent: true, opacity: 0.3
      });
      const outerMesh = new THREE.Mesh(outerGeo, outerMat);
      this.group.add(outerMesh);

      const starsGeo = new THREE.BufferGeometry();
      const starsCount = 200;
      const posArray = new Float32Array(starsCount * 3);
      for (let i = 0; i < starsCount * 3; i += 3) {
        const r = 3.5 + Math.random() * 1.5;
        const theta = Math.random() * Math.PI * 2;
        const phi = Math.acos((Math.random() * 2) - 1);
        posArray[i] = r * Math.sin(phi) * Math.cos(theta);
        posArray[i + 1] = r * Math.sin(phi) * Math.sin(theta);
        posArray[i + 2] = r * Math.cos(phi);
      }
      starsGeo.setAttribute('position', new THREE.BufferAttribute(posArray, 3));
      const starsMat = new THREE.PointsMaterial({ color: 0x8be9fd, size: 0.05 });
      const stars = new THREE.Points(starsGeo, starsMat);
      this.group.add(stars);

      for (let i = 0; i < 3; i++) {
        const ballGeo = new THREE.SphereGeometry(0.2, 16, 16);
        const ballMat = new THREE.MeshBasicMaterial({ color: 0xffbd2e });
        const ball = new THREE.Mesh(ballGeo, ballMat);
        ball.userData.angle = (i / 3) * Math.PI * 2;
        ball.userData.radius = 3.2 + i * 0.3;
        this.group.add(ball);
      }

      this.scene.add(this.group);

      window.addEventListener('mousemove', this.handleGlobalMouseMove);
    },
    handleGlobalMouseMove(e) {
      this.targetRotY = ((e.clientX / window.innerWidth) - 0.5) * 2;
      this.targetRotX = ((e.clientY / window.innerHeight) - 0.5) * 2;
    },
    animate() {
      this.animationId = requestAnimationFrame(this.animate);
      const time = performance.now() * 0.001;

      this.group.children[0].rotation.x += 0.01;
      this.group.children[0].rotation.y += 0.005;

      this.group.children[1].rotation.x -= 0.005;
      this.group.children[1].rotation.z += 0.005;

      this.group.children[2].rotation.y += 0.002;
      for (let i = 3; i < this.group.children.length; i++) {
        const ball = this.group.children[i];
        ball.userData.angle += 0.01;
        ball.position.x = Math.cos(ball.userData.angle) * ball.userData.radius;
        ball.position.z = Math.sin(ball.userData.angle) * ball.userData.radius;
      }

      this.group.rotation.y += (this.targetRotY * 0.6 - this.group.rotation.y) * 0.05;
      this.group.rotation.x += (this.targetRotX * 0.6 - this.group.rotation.x) * 0.05;

      this.renderer.render(this.scene, this.camera);
    },
    navTo(url) {
      this.$router.push(url);
    },
    sendMessage() {
      this.form = {
        name: '',
        email: '',
        phone: '',
        country: '',
        inquiry: '',
        message: '',
        terms: false
      }
    }
  }
}
</script>

<style scoped>
.contact-hero {
  background-color: #070b14;
  padding: 80px 10%;
  color: #e2e8f0;
  font-family: sans-serif;
}

.hero-top {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  margin-bottom: 80px;
}

.tag {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #4fd1c5;
  font-size: 0.75rem;
  letter-spacing: 2px;
  margin-bottom: 20px;
}

.pulse-dot {
  width: 8px;
  height: 8px;
  background: #4fd1c5;
  border-radius: 50%;
  display: inline-block;
  box-shadow: 0 0 10px #4fd1c5;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  50% {
    opacity: 0.2;
  }
}

.main-title {
  font-size: 3.5rem;
  line-height: 1.1;
  font-weight: 800;
  margin: 0 0 20px;
}

.gradient-text {
  background: linear-gradient(90deg, #4fd1c5, #8be9fd);
  -webkit-background-clip: text;
  color: transparent;
}

.description {
  color: #94a3b8;
  font-size: 0.9rem;
  line-height: 1.8;
  margin-bottom: 30px;
  max-width: 500px;
}

.hero-buttons {
  display: flex;
  gap: 15px;
  margin-bottom: 40px;
}

.btn-primary {
  background: #4fd1c5;
  color: #000;
  border: none;
  padding: 12px 20px;
  font-size: 0.9rem;
  font-weight: bold;
  border-radius: 6px;
  cursor: pointer;
}

.btn-secondary {
  background: transparent;
  border: 1px solid #253045;
  color: #fff;
  padding: 12px 20px;
  font-size: 0.9rem;
  border-radius: 6px;
  cursor: pointer;
}

.quick-stats {
  display: flex;
  gap: 20px;
}

.q-stat {
  background: #0d1117;
  border: 1px solid #253045;
  border-radius: 50px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.8rem;
}

.q-stat strong {
  display: block;
  color: #fff;
}

.q-stat .sub {
  color: #4fd1c5;
  font-size: 0.7rem;
  letter-spacing: 1px;
}

.right-visual {
  position: relative;
  height: 500px;
}

.three-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.status-card {
  position: absolute;
  background: rgba(13, 17, 23, 0.9);
  border: 1px solid #253045;
  border-radius: 8px;
  padding: 20px;
  width: 150px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
  z-index: 2;
}

.sc-label {
  color: #94a3b8;
  font-size: 0.7rem;
  letter-spacing: 1px;
  margin-bottom: 10px;
}

.sc-num {
  color: #fff;
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 5px;
}

.sc-status {
  color: #4fd1c5;
  font-size: 0.7rem;
  margin-bottom: 15px;
}

.bar {
  width: 100%;
  height: 4px;
  background: #253045;
  border-radius: 2px;
  overflow: hidden;
}

.bar::after {
  content: '';
  display: block;
  width: 50%;
  height: 100%;
  background: #4fd1c5;
}

.sc-1 {
  top: 80px;
  left: 0;
}

.sc-2 {
  top: 180px;
  right: 0;
}

.sc-3 {
  bottom: 120px;
  left: 20px;
}

.sc-4 {
  bottom: 30px;
  right: 20px;
}

.channel-badge {
  position: absolute;
  top: 10px;
  right: 0;
  background: rgba(13, 17, 23, 0.9);
  border: 1px solid #4fd1c5;
  border-radius: 50px;
  padding: 8px 15px;
  color: #4fd1c5;
  font-size: 0.8rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
  z-index: 2;
}

.hero-bottom {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 40px;
}

.form-card {
  background: #0a101f;
  border: 1px solid #253045;
  border-radius: 10px;
  padding: 40px;
}

.form-title {
  color: #4fd1c5;
  font-size: 1.8rem;
  margin-bottom: 20px;
}

.form-desc {
  color: #94a3b8;
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 30px;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

label {
  color: #4fd1c5;
  font-size: 0.8rem;
  margin-bottom: 10px;
}

input,
select,
textarea {
  background: #05070e;
  border: 1px solid #253045;
  border-radius: 6px;
  padding: 12px;
  color: #fff;
  font-size: 0.9rem;
  outline: none;
}

textarea {
  height: 120px;
  resize: none;
  margin-bottom: 20px;
}

select {
  margin-bottom: 20px;
}

.terms {
  color: #94a3b8;
  font-size: 0.8rem;
  display: block;
  margin-bottom: 20px;
  cursor: pointer;
}

.send-btn {
  width: 100%;
  background: #00d68f;
  border: none;
  padding: 15px;
  color: #000;
  font-weight: bold;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
}

.info-panel {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.info-card {
  position: relative;
  background: #0d1117;
  border: 1px solid #253045;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  gap: 15px;
  font-size: 0.85rem;
  align-items: center;
  overflow: hidden;
  transition: transform 0.2s;
}

.info-card::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 0%;
  transition: height 0.3s ease;
}

.info-card:hover::before {
  height: 100%;
}

.color-1::before {
  background: #4fd1c5;
}

.color-2::before {
  background: #ffbd2e;
}

.color-3::before {
  background: #ff5f56;
}

.color-4::before {
  background: #c77dff;
}

.color-5::before {
  background: #27c93f;
}

.color-6::before {
  background: #ff9f43;
}

.info-icon {
  font-size: 1.5rem;
}

.value {
  color: #94a3b8;
  font-size: 0.9rem;
}

.hours-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
  font-size: 0.75rem;
  color: #94a3b8;
  margin-top: 10px;
}

.icon-container {
  position: relative;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.ring-anim {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 2px dashed #4fd1c5;
  border-radius: 50%;
  animation: spin 3s linear infinite;
}

.ring-text {
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

.ic-title {
  font-size: 0.75rem;
  color: #94a3b8;
  margin-bottom: 5px;
}

.info-card p {
  margin: 0;
  color: #94a3b8;
  font-size: 0.8rem;
  line-height: 1.4;
}

@media (max-width: 900px) {

  .hero-top,
  .hero-bottom {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .right-visual {
    order: -1;
    height: 350px;
    overflow: hidden;
  }

  .status-card {
    width: 100px;
    padding: 10px;
  }

  .sc-label {
    font-size: 0.6rem;
  }

  .sc-num {
    font-size: 1.2rem;
  }

  .sc-status {
    font-size: 0.6rem;
  }

  .sc-1 {
    top: 20px;
    left: 0;
  }

  .sc-2 {
    top: 50px;
    right: 0;
  }

  .sc-3 {
    bottom: 50px;
    left: 10px;
  }

  .sc-4 {
    bottom: 20px;
    right: 10px;
  }

  .channel-badge {
    right: 0;
    font-size: 0.6rem;
  }

  .quick-stats {
    flex-direction: column;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .main-title {
    font-size: 2.5rem;
  }
}
</style>